import script from "./ReportToIT.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportToIT.vue?vue&type=script&setup=true&lang=js"

import "./ReportToIT.vue?vue&type=style&index=0&id=61bf719b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61bf719b"]])

export default __exports__